export default __webpack_public_path__ + "static/media/Location.4fa3947b.svg";